(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clm-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function inicializarFaq(raiz) {
    var items = raiz.querySelectorAll('.clm-faq-item');
    items.forEach(function (item) {
      var resumen = item.querySelector('.clm-faq-pregunta');
      var panel = item.querySelector('.clm-faq-respuesta-contenedor');
      if (!resumen || !panel) return;

      if (item.hasAttribute('open')) {
        panel.style.height = 'auto';
      }

      resumen.addEventListener('click', function (evento) {
        evento.preventDefault();
        var estaAbierto = item.hasAttribute('open');

        if (estaAbierto) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () {
            panel.style.height = '0px';
          });
          panel.addEventListener(
            'transitionend',
            function manejador() {
              item.removeAttribute('open');
              panel.removeEventListener('transitionend', manejador);
            },
            { once: true }
          );
        } else {
          item.setAttribute('open', '');
          panel.style.height = '0px';
          requestAnimationFrame(function () {
            panel.style.height = panel.scrollHeight + 'px';
          });
          panel.addEventListener(
            'transitionend',
            function manejador() {
              panel.style.height = 'auto';
              panel.removeEventListener('transitionend', manejador);
            },
            { once: true }
          );
        }
      });
    });
  }

  document.querySelectorAll('.clm-faq').forEach(inicializarFaq);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clm-ticker-anuncios"] && !Shopify.designMode) return;
  try {
    
(function () {
  function inicializarTicker(raiz) {
    var pista = raiz.querySelector('.clm-ticker-pista');
    if (!pista) return;

    var velocidadSegundos = parseFloat(raiz.dataset.velocidad) || 24;
    var pausarEnHover = raiz.dataset.pausarHover === 'true';
    var offset = 0;
    var anchoMitad = 0;
    var pausado = false;
    var ultimoTiempo = null;

    function medir() {
      anchoMitad = pista.scrollWidth / 2;
    }

    medir();
    window.addEventListener('resize', medir);
    window.addEventListener('load', medir);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(medir);
    }
    setTimeout(medir, 500);
    setTimeout(medir, 1500);

    if (pausarEnHover) {
      raiz.addEventListener('mouseenter', function () {
        pausado = true;
      });
      raiz.addEventListener('mouseleave', function () {
        pausado = false;
      });
    }

    function avanzar(tiempoActual) {
      if (ultimoTiempo === null) {
        ultimoTiempo = tiempoActual;
      }
      var delta = (tiempoActual - ultimoTiempo) / 1000;
      ultimoTiempo = tiempoActual;

      if (!pausado && anchoMitad > 0) {
        var pixelesPorSegundo = anchoMitad / velocidadSegundos;
        offset -= pixelesPorSegundo * delta;
        if (offset <= -anchoMitad) {
          offset += anchoMitad;
        }
        pista.style.transform = 'translateX(' + offset + 'px)';
      }

      requestAnimationFrame(avanzar);
    }

    requestAnimationFrame(avanzar);
  }

  document.querySelectorAll('.clm-ticker').forEach(inicializarTicker);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
